import { useAtomValue, useSetAtom } from "jotai";
import {
  areAnySavesInFlightAtom,
  decrementInFlightSavesCountAtom,
  incrementInFlightSavesCountAtom,
} from "@/atoms/savingIndicatorAtom";

export const useGlobalSavingIndicator = () => {
  const incrementInFlightSavesCount = useSetAtom(incrementInFlightSavesCountAtom);
  const decrementInFlightSavesCount = useSetAtom(decrementInFlightSavesCountAtom);

  const withGlobalSavingIndicator = async (callback: () => Promise<unknown>) => {
    incrementInFlightSavesCount();
    try {
      await callback();
    } finally {
      decrementInFlightSavesCount();
    }
  };

  const isSaving = useAtomValue(areAnySavesInFlightAtom);

  return {
    withGlobalSavingIndicator,
    isSaving,
  };
};
